import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const NearMissSummaryCards = ({ stats, onFilter, activeFilter }) => {
  const { t } = useLanguage();

  const cards = [
    {
      key: 'total',
      label: t('nearMissCardTotal'),
      value: stats?.total ?? 0,
      icon: 'AlertTriangle',
      iconBg: 'bg-slate-100',
      iconColor: 'text-slate-600',
      borderColor: 'border-border',
      activeColor: 'border-slate-400 bg-slate-50',
    },
    {
      key: 'Open',
      label: t('nearMissStatusOpen'),
      value: stats?.open ?? 0,
      icon: 'AlertCircle',
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      borderColor: 'border-border',
      activeColor: 'border-red-400 bg-red-50',
    },
    {
      key: 'Under review',
      label: t('nearMissStatusUnderReview'),
      value: stats?.underReview ?? 0,
      icon: 'Search',
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      borderColor: 'border-border',
      activeColor: 'border-amber-400 bg-amber-50',
    },
    {
      key: 'Closed',
      label: t('nearMissStatusClosed'),
      value: stats?.closed ?? 0,
      icon: 'CheckCircle2',
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600',
      borderColor: 'border-border',
      activeColor: 'border-emerald-400 bg-emerald-50',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
      {cards?.map(card => {
        const isActive = activeFilter === card?.key;
        return (
          <button
            key={card?.key}
            onClick={() => onFilter?.(isActive ? null : card?.key)}
            className={`bg-card rounded-xl border-2 p-4 text-left transition-all hover:shadow-md ${
              isActive ? card?.activeColor : card?.borderColor + ' hover:border-accent/40'
            }`}
          >
            <div className="flex items-center gap-3 mb-2">
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${card?.iconBg}`}>
                <Icon name={card?.icon} size={18} className={card?.iconColor} />
              </div>
            </div>
            <p className="text-2xl font-bold text-foreground font-heading">{card?.value}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{card?.label}</p>
          </button>
        );
      })}
    </div>
  );
};

export default NearMissSummaryCards;
